package com.schoolconnect.app.feature.imports

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import com.schoolconnect.app.designsystem.AppDropdownMenu
import com.schoolconnect.app.designsystem.AppPageHeader
import com.schoolconnect.app.designsystem.AppPageSubtitle
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.schoolconnect.app.designsystem.AppBackground
import com.schoolconnect.app.designsystem.AppBorder
import com.schoolconnect.app.designsystem.AppDanger
import com.schoolconnect.app.designsystem.AppDangerSoft
import com.schoolconnect.app.designsystem.AppInputBorder
import com.schoolconnect.app.designsystem.AppLine
import com.schoolconnect.app.designsystem.AppMuted
import com.schoolconnect.app.designsystem.AppNavy
import com.schoolconnect.app.designsystem.AppPrimary
import com.schoolconnect.app.designsystem.AppPrimarySoft
import com.schoolconnect.app.designsystem.AppPurpleSoft
import com.schoolconnect.app.designsystem.AppPurpleText
import com.schoolconnect.app.designsystem.AppSecondaryBackground
import com.schoolconnect.app.designsystem.AppSoftSurface
import com.schoolconnect.app.designsystem.AppSurface
import com.schoolconnect.app.designsystem.AppSuccess
import com.schoolconnect.app.designsystem.AppSuccessSoft
import com.schoolconnect.app.designsystem.AppInfoBg
import com.schoolconnect.app.designsystem.ApiLoadingOverlay
import com.schoolconnect.app.designsystem.AppConfirmationDialog
import com.schoolconnect.app.designsystem.AppConfirmationDialogTone
import io.github.vinceglb.filekit.compose.rememberFilePickerLauncher
import io.github.vinceglb.filekit.core.PickerType
import com.schoolconnect.app.designsystem.list.AdminListHeaderColumn
import com.schoolconnect.app.designsystem.list.AdminListSpreadsheetCell
import com.schoolconnect.app.designsystem.list.AdminListSpreadsheetGridOverlay
import com.schoolconnect.app.designsystem.list.AdminListSpreadsheetHeaderRow
import com.schoolconnect.app.designsystem.list.AdminListSpreadsheetRow
import com.schoolconnect.app.designsystem.list.AdminListPagination
import com.schoolconnect.app.designsystem.list.AdminListRowsPerPageButton
import com.schoolconnect.app.designsystem.list.AdminListTableCard
import com.schoolconnect.app.designsystem.list.AdminListTableBody
import com.schoolconnect.app.feature.common.ShellPageHeader
import com.schoolconnect.app.theme.interBold
import com.schoolconnect.app.theme.interMedium
import com.schoolconnect.app.theme.interSemiBold
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.arrow_left
import ischoolconnect.sharedui.generated.resources.arrow_right
import ischoolconnect.sharedui.generated.resources.check_circle_filled
import ischoolconnect.sharedui.generated.resources.circle_check
import ischoolconnect.sharedui.generated.resources.close_x
import ischoolconnect.sharedui.generated.resources.chevron_down
import ischoolconnect.sharedui.generated.resources.chevron_left
import ischoolconnect.sharedui.generated.resources.chevron_right
import ischoolconnect.sharedui.generated.resources.calendar
import ischoolconnect.sharedui.generated.resources.clipboard_check
import ischoolconnect.sharedui.generated.resources.cloud_upload
import ischoolconnect.sharedui.generated.resources.database_download
import ischoolconnect.sharedui.generated.resources.download
import ischoolconnect.sharedui.generated.resources.double_chevron_left
import ischoolconnect.sharedui.generated.resources.double_chevron_right
import ischoolconnect.sharedui.generated.resources.document
import ischoolconnect.sharedui.generated.resources.excel_file
import ischoolconnect.sharedui.generated.resources.file_xlsx
import ischoolconnect.sharedui.generated.resources.filter
import ischoolconnect.sharedui.generated.resources.records_list
import org.jetbrains.compose.resources.painterResource
import kotlinx.coroutines.launch
import com.schoolconnect.app.util.MAX_WORKBOOK_BYTES
import kotlinx.coroutines.yield

internal val ImportsBackground = AppSecondaryBackground
internal val ImportsSurface = AppSurface
internal val ImportsBorder = AppBorder
internal val ImportsLine = AppLine
internal val ImportsNavy = AppNavy
internal val ImportsMuted = AppMuted
internal val ImportsPrimary = AppPrimary
internal val ImportsPrimaryHover = Color(0xFF084BE0)
internal val ImportsSuccess = AppSuccess
internal val ImportsSuccessBg = AppSuccessSoft
internal val ImportsDanger = AppDanger
internal val ImportsDangerBg = AppDangerSoft
internal val ImportsPurple = AppPurpleText
internal val ImportsPurpleBg = AppPurpleSoft
internal val ImportsSoftSurface = AppSoftSurface
internal val ImportsMaleBg = AppPrimarySoft
internal val ImportsMaleText = AppPrimary
internal val ImportsFemaleBg = AppPurpleSoft
internal val ImportsFemaleText = AppPurpleText
private val ImportReviewRowPadding = 8.dp
private val ImportReviewRowHeight = 56.dp
private val ImportReviewAssignmentRowMinHeight = 56.dp
private val ImportReviewChipPaddingY = 3.dp
private val ImportFooterButtonHeight = 50.dp
private val ImportFooterButtonWidth = 280.dp
private val ImportStaffTableMinWidth = 1360.dp
private val ImportSubjectTableMinWidth = 980.dp
private val ImportClassTableMinWidth = 1020.dp
private val ImportAssignmentTableMinWidth = 1380.dp

@Composable
fun ImportsPageHeader(
    title: String,
    subtitle: String,
    contextLine: String? = null,
    headerActions: @Composable RowScope.() -> Unit = {},
    modifier: Modifier = Modifier
) {
    ShellPageHeader(
        title = title,
        subtitle = subtitle,
        detailText = contextLine,
        modifier = modifier,
        titleColor = AppPageHeader,
        subtitleColor = AppPageSubtitle,
        detailColor = ImportsMuted,
        headerActions = headerActions
    )
}

@Composable
fun BackToBulkImportButton(
    label: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    ImportsOutlineButton(
        label = label,
        icon = painterResource(Res.drawable.arrow_left),
        onClick = onClick,
        modifier = modifier,
        borderColor = ImportsBorder,
        contentColor = ImportsPrimary,
        height = ImportFooterButtonHeight,
        horizontalPadding = 22.dp
    )
}

@Composable
fun ImportsPageHeaderBar(
    title: String,
    subtitle: String,
    backButtonLabel: String,
    onBackButtonClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    Row(
        modifier = modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.Top
    ) {
        ImportsPageHeader(
            title = title,
            subtitle = subtitle,
            headerActions = {}
        )
        BackToBulkImportButton(
            label = backButtonLabel,
            onClick = onBackButtonClick
        )
    }
}

@Composable
private fun ImportsOutlineButton(
    label: String,
    icon: Painter? = null,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    borderColor: Color,
    contentColor: Color,
    backgroundColor: Color = ImportsSurface,
    height: Dp = 44.dp,
    horizontalPadding: Dp = 16.dp
    ) {
    Surface(
        modifier = modifier
            .height(height)
            .clickable(onClick = onClick),
        shape = RoundedCornerShape(8.dp),
        color = backgroundColor,
        border = androidx.compose.foundation.BorderStroke(1.dp, borderColor)
    ) {
        Row(
            modifier = Modifier.padding(horizontal = horizontalPadding),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Center
        ) {
            if (icon != null) {
                Icon(painter = icon, contentDescription = null, tint = contentColor)
                Spacer(modifier = Modifier.width(8.dp))
            }
            Text(
                text = label,
                color = contentColor,
                fontFamily = interSemiBold(),
                fontWeight = FontWeight.SemiBold,
                fontSize = 14.sp,
                maxLines = 1,
                softWrap = false,
                overflow = TextOverflow.Ellipsis,
                textAlign = TextAlign.Center
            )
        }
    }
}

@Composable
private fun ImportsFilledButton(
    label: String,
    icon: Painter,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    backgroundColor: Color = ImportsPrimary,
    contentColor: Color = Color.White,
    height: Dp = 44.dp,
    horizontalPadding: Dp = 18.dp,
    enabled: Boolean = true
) {
    Surface(
        modifier = modifier
            .height(height)
            .clickable(enabled = enabled, onClick = onClick),
        shape = RoundedCornerShape(8.dp),
        color = backgroundColor.copy(alpha = if (enabled) 1f else 0.65f)
    ) {
        Row(
            modifier = Modifier.padding(horizontal = horizontalPadding),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Center
        ) {
            Icon(painter = icon, contentDescription = null, tint = contentColor)
            Spacer(modifier = Modifier.width(8.dp))
            Text(
                text = label,
                color = contentColor,
                fontFamily = interSemiBold(),
                fontWeight = FontWeight.SemiBold,
                fontSize = 14.sp,
                maxLines = 1,
                softWrap = false,
                overflow = TextOverflow.Ellipsis,
                textAlign = TextAlign.Center
            )
        }
    }
}

@Composable
fun ImportsStepper(
    steps: List<ImportStepUiModel>,
    modifier: Modifier = Modifier
) {
    Card(
        modifier = modifier.fillMaxWidth(),
        shape = RoundedCornerShape(8.dp),
        colors = CardDefaults.cardColors(containerColor = ImportsSurface),
        border = androidx.compose.foundation.BorderStroke(1.dp, ImportsBorder)
    ) {
        BoxWithConstraints(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 24.dp, vertical = 14.dp)
        ) {
            val compact = maxWidth < 820.dp
            if (compact) {
                Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
                    steps.forEachIndexed { index, step ->
                        ImportStepperItem(step = step)
                        if (index != steps.lastIndex) {
                            HorizontalDivider(color = ImportsLine)
                        }
                    }
                }
            } else {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    ImportStepperItem(step = steps.getOrNull(0) ?: return@BoxWithConstraints)
                    Spacer(modifier = Modifier.width(28.dp))
                    Box(
                        modifier = Modifier
                            .height(2.dp)
                            .weight(1f)
                            .padding(horizontal = 20.dp)
                            .background(ImportsPrimary, RoundedCornerShape(999.dp))
                    )
                    Spacer(modifier = Modifier.width(28.dp))
                    ImportStepperItem(step = steps.getOrNull(1) ?: return@BoxWithConstraints)
                }
            }
        }
    }
}

@Composable
private fun ImportStepperItem(
    step: ImportStepUiModel,
    modifier: Modifier = Modifier
) {
    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(16.dp)
    ) {
        Box(
            modifier = Modifier
                .size(44.dp)
                .background(
                    when {
                        step.isCompleted -> Color.Transparent
                        step.isActive -> ImportsPrimary
                        else -> Color(0xFFE7EAF2)
                    },
                    CircleShape
                ),
            contentAlignment = Alignment.Center
        ) {
            when {
                step.isCompleted -> Icon(
                    painter = painterResource(Res.drawable.check_circle_filled),
                    contentDescription = null,
                    tint = Color.Unspecified,
                    modifier = Modifier.size(44.dp)
                )
                else -> Text(
                    text = step.number.toString(),
                    color = if (step.isActive) Color.White else ImportsNavy,
                    style = MaterialTheme.typography.titleMedium,
                    fontWeight = FontWeight.ExtraBold
                )
            }
        }
        Column(verticalArrangement = Arrangement.spacedBy(4.dp)) {
            Text(
                text = step.title,
                color = when {
                    step.isActive || step.isCompleted -> ImportsPrimary
                    else -> ImportsNavy
                },
                fontFamily = interSemiBold(),
                fontWeight = FontWeight.SemiBold
            )
            Text(
                text = step.subtitle,
                color = ImportsNavy,
                style = MaterialTheme.typography.bodyMedium,
                fontWeight = FontWeight.Medium
            )
        }
    }
}

@Composable
fun ImportSummaryCard(
    index: Int,
    title: String,
    subtitle: String,
    icon: Painter,
    iconTint: Color,
    iconBackground: Color,
    rows: List<ImportSummaryRow>,
    modifier: Modifier = Modifier,
    cardHeight: Dp = 408.dp,
    footer: @Composable ColumnScope.() -> Unit = {}
) {
    Card(
        // Keep all summary cards aligned when they share a wide-screen row.
        // Their content is designed for this fixed shared height; using only
        // heightIn lets each card choose a different intrinsic height.
        modifier = modifier.height(cardHeight),
        shape = RoundedCornerShape(8.dp),
        colors = CardDefaults.cardColors(containerColor = ImportsSurface),
        border = androidx.compose.foundation.BorderStroke(1.dp, ImportsBorder)
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .fillMaxHeight()
                .padding(horizontal = 18.dp, vertical = 16.dp),
            verticalArrangement = Arrangement.SpaceBetween
        ) {
            Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.spacedBy(12.dp),
                    verticalAlignment = Alignment.Top
                ) {
                    NumberBadge(number = index)
                    IconBadge(icon = icon, iconTint = iconTint, background = iconBackground)
                    Column(verticalArrangement = Arrangement.spacedBy(6.dp)) {
                        Text(
                            text = title,
                            color = ImportsNavy,
                            style = MaterialTheme.typography.titleMedium,
                            fontWeight = FontWeight.ExtraBold
                        )
                        Text(
                            text = subtitle,
                            color = ImportsNavy,
                            style = MaterialTheme.typography.bodyMedium,
                            fontWeight = FontWeight.Medium
                        )
                    }
                }

                Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
                    rows.forEachIndexed { rowIndex, row ->
                        if (rowIndex > 0) {
                            HorizontalDivider(color = ImportsLine)
                        }
                        ImportKeyValueRow(row)
                    }
                }
            }

            footer()
        }
    }
}

@Composable
private fun NumberBadge(number: Int) {
    Box(
        modifier = Modifier
            .size(30.dp)
            .clip(CircleShape)
            .border(2.dp, ImportsPrimary, CircleShape),
        contentAlignment = Alignment.Center
    ) {
        Text(
            text = number.toString(),
            color = ImportsPrimary,
            style = MaterialTheme.typography.titleSmall,
            fontWeight = FontWeight.ExtraBold
        )
    }
}

@Composable
private fun IconBadge(
    icon: Painter,
    iconTint: Color,
    background: Color
) {
    Box(
        modifier = Modifier
            .size(66.dp)
            .background(background, CircleShape),
        contentAlignment = Alignment.Center
    ) {
        Icon(
            painter = icon,
            contentDescription = null,
            tint = iconTint,
            modifier = Modifier.size(34.dp)
        )
    }
}

@Composable
private fun ImportKeyValueRow(
    row: ImportSummaryRow,
    modifier: Modifier = Modifier
) {
    Row(
        modifier = modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(16.dp),
        verticalAlignment = Alignment.Top
    ) {
        Text(
            text = row.label,
            color = ImportsNavy,
            style = MaterialTheme.typography.bodyMedium,
            fontWeight = FontWeight.Medium,
            modifier = Modifier.weight(0.34f)
        )
        when {
            row.badgeText != null -> {
                Box(
                    modifier = Modifier.weight(0.66f),
                    contentAlignment = Alignment.CenterEnd
                ) {
                    Surface(
                        color = row.badgeBackground,
                        shape = RoundedCornerShape(8.dp)
                    ) {
                        Text(
                            text = row.badgeText,
                            color = row.badgeColor,
                            style = MaterialTheme.typography.labelLarge,
                            fontWeight = FontWeight.Bold,
                            modifier = Modifier.padding(horizontal = 12.dp, vertical = 6.dp)
                        )
                    }
                }
            }
            else -> Text(
                text = row.value,
                color = row.valueColor,
                style = MaterialTheme.typography.bodyMedium,
                fontWeight = FontWeight.ExtraBold,
                textAlign = TextAlign.End,
                maxLines = 3,
                overflow = TextOverflow.Ellipsis,
                modifier = Modifier.weight(0.66f)
            )
        }
    }
}

@Composable
fun ImportCardActionButton(
    label: String,
    icon: Painter,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    contentColor: Color = ImportsPrimary,
    borderColor: Color = ImportsPrimary,
    height: Dp = 46.dp,
    horizontalPadding: Dp = 14.dp
) {
    ImportsOutlineButton(
        label = label,
        icon = icon,
        onClick = onClick,
        modifier = modifier,
        borderColor = borderColor,
        contentColor = contentColor,
        height = height,
        horizontalPadding = horizontalPadding
    )
}

@Composable
fun ImportToolbar(
    selectedSheet: String,
    sheetOptions: List<String>,
    onSheetSelected: (String) -> Unit,
    onFilterClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    var expanded by remember { mutableStateOf(false) }

    Row(
        modifier = modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.End,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Box {
            SheetPickerButton(
                label = selectedSheet,
                onClick = { expanded = true }
            )
            AppDropdownMenu(
                expanded = expanded,
                onDismissRequest = { expanded = false }
            ) {
                sheetOptions.forEach { option ->
                    DropdownMenuItem(
                        text = { Text(option) },
                        onClick = {
                            expanded = false
                            onSheetSelected(option)
                        }
                    )
                }
            }
        }
        Spacer(modifier = Modifier.width(20.dp))
        FilterButton(onClick = onFilterClick)
    }
}

@Composable
private fun SheetPickerButton(
    label: String,
    onClick: () -> Unit
) {
    Surface(
        color = ImportsSurface,
        shape = RoundedCornerShape(8.dp),
        border = androidx.compose.foundation.BorderStroke(1.dp, ImportsBorder)
    ) {
        Row(
            modifier = Modifier
                .height(40.dp)
                .clickable(onClick = onClick)
                .padding(horizontal = 18.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(12.dp)
        ) {
            Text(
                text = label,
                color = ImportsPrimary,
                fontFamily = interSemiBold(),
                fontWeight = FontWeight.SemiBold
            )
            Icon(
                painter = painterResource(Res.drawable.chevron_down),
                contentDescription = null,
                tint = ImportsPrimary,
                modifier = Modifier.size(18.dp)
            )
        }
    }
}

@Composable
private fun FilterButton(onClick: () -> Unit) {
    ImportsOutlineButton(
        label = "Filters",
        icon = painterResource(Res.drawable.filter),
        onClick = onClick,
        borderColor = ImportsBorder,
        contentColor = ImportsNavy,
        height = 44.dp,
        horizontalPadding = 18.dp
    )
}

@Composable
fun ImportErrorTableCard(
    totalErrorsLabel: String,
    helpText: String,
    sheetOptions: List<String>,
    selectedSheet: String,
    onSheetSelected: (String) -> Unit,
    onFilterClick: () -> Unit,
    rows: List<ImportErrorRow>,
    pageText: String,
    pageIndex: Int,
    pageCount: Int,
    onPageChanged: (Int) -> Unit,
    modifier: Modifier = Modifier,
    onDownloadErrorDetails: (() -> Unit)? = null
) {
    val safePageCount = pageCount.coerceAtLeast(1)
    val safePageIndex = pageIndex.coerceIn(0, safePageCount - 1)
    val pageSize = errorPageSize(rows.size, safePageCount)
    val visibleRows = remember(rows, pageSize, safePageIndex) {
        val fromIndex = safePageIndex * pageSize
        if (fromIndex >= rows.size) {
            emptyList()
        } else {
            rows.drop(fromIndex).take(pageSize)
        }
    }
    val visiblePageText = buildErrorPageText(
        pageIndex = safePageIndex,
        totalErrors = rows.size,
        pageSize = pageSize
    )

    Card(
        modifier = modifier
            .fillMaxWidth()
            .height(346.dp),
        shape = RoundedCornerShape(8.dp),
        colors = CardDefaults.cardColors(containerColor = ImportsSurface),
        border = androidx.compose.foundation.BorderStroke(1.dp, ImportsBorder)
    ) {
        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(horizontal = 14.dp, vertical = 14.dp),
            verticalArrangement = Arrangement.spacedBy(12.dp)
        ) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Column(verticalArrangement = Arrangement.spacedBy(6.dp)) {
                Text(
                    text = totalErrorsLabel,
                    color = ImportsDanger,
                    style = MaterialTheme.typography.titleLarge,
                    fontWeight = FontWeight.ExtraBold
                )
                Text(
                    text = helpText,
                    color = ImportsNavy,
                    style = MaterialTheme.typography.bodyMedium,
                    fontWeight = FontWeight.Medium
                )
            }

            ImportToolbar(
                selectedSheet = selectedSheet,
                sheetOptions = sheetOptions,
                onSheetSelected = onSheetSelected,
                onFilterClick = onFilterClick
            )
        }

        AdminListTableCard(
            modifier = Modifier
                .fillMaxWidth()
                .weight(1f),
            surfaceColor = ImportsSurface,
            borderColor = ImportsBorder,
            header = {
                AdminListSpreadsheetHeaderRow(
                    columns = listOf(
                        AdminListHeaderColumn("Sheet Name", 0.18f),
                        AdminListHeaderColumn("Row No.", 0.12f),
                        AdminListHeaderColumn("Status", 0.12f),
                        AdminListHeaderColumn("Error Message", 0.58f)
                    ),
                    height = 42.dp,
                    horizontalPadding = 14.dp,
                    showVerticalDividers = false,
                    labelColor = ImportsNavy
                )
            },
            body = {
                if (visibleRows.isEmpty()) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .weight(1f),
                        contentAlignment = Alignment.Center
                    ) {
                        Text(
                            text = "No errors to display",
                            color = ImportsMuted,
                            fontWeight = FontWeight.Medium
                        )
                    }
                } else {
                    AdminListTableBody(
                        modifier = Modifier
                            .fillMaxWidth()
                            .weight(1f),
                        items = visibleRows,
                        key = { it.id }
                    ) { row ->
                        ImportErrorRowItem(row = row)
                        HorizontalDivider(color = ImportsBorder)
                    }
                }
            },
            footer = {
                ImportErrorTableFooter(
                    pageText = visiblePageText.ifBlank { pageText },
                    pageIndex = safePageIndex,
                    pageCount = safePageCount,
                    onPageChanged = onPageChanged,
                    onDownloadErrorDetails = onDownloadErrorDetails
                )
            }
        )
        }
    }
}

@Composable
private fun ImportErrorRowItem(row: ImportErrorRow) {
    AdminListSpreadsheetRow(
        cells = listOf(
            AdminListSpreadsheetCell(0.18f) { ImportSpreadsheetText(row.sheetName, color = ImportsNavy) },
            AdminListSpreadsheetCell(0.12f) { ImportSpreadsheetText(row.rowNo, color = ImportsNavy) },
            AdminListSpreadsheetCell(0.12f) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(8.dp)
                ) {
                    Icon(
                        painter = painterResource(Res.drawable.close_x),
                        contentDescription = null,
                        tint = ImportsDanger,
                        modifier = Modifier.size(22.dp)
                    )
                    Text(
                        text = "Error",
                        color = ImportsDanger,
                        fontWeight = FontWeight.Bold
                    )
                }
            },
            AdminListSpreadsheetCell(0.58f) { ImportSpreadsheetMultilineText(row.message, color = ImportsNavy) }
        ),
        height = null,
        minHeight = 44.dp,
        horizontalPadding = 14.dp,
        showVerticalDividers = false,
        backgroundColor = ImportsSurface,
        dividerColor = ImportsBorder
    )
}

@Composable
private fun ImportErrorTableFooter(
    pageText: String,
    pageIndex: Int,
    pageCount: Int,
    onPageChanged: (Int) -> Unit,
    onDownloadErrorDetails: (() -> Unit)?
) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 6.dp, vertical = 10.dp)
    ) {
        onDownloadErrorDetails?.let { download ->
            ImportsOutlineButton(
                label = "Download Error Details",
                icon = painterResource(Res.drawable.download),
                onClick = download,
                modifier = Modifier.align(Alignment.CenterStart),
                borderColor = ImportsPrimary,
                contentColor = ImportsPrimary,
                height = 42.dp
            )
        }

        Row(
            modifier = Modifier.align(Alignment.Center),
            horizontalArrangement = Arrangement.spacedBy(8.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(
                text = pageText,
                color = ImportsNavy,
                fontFamily = interSemiBold(),
                fontWeight = FontWeight.SemiBold
            )
        }

        PaginationRow(
            pageIndex = pageIndex,
            pageCount = pageCount,
            onPageChanged = onPageChanged,
            modifier = Modifier.align(Alignment.CenterEnd)
        )
    }
}

private fun errorPageSize(totalErrors: Int, pageCount: Int): Int {
    val safeTotalErrors = totalErrors.coerceAtLeast(1)
    val safePageCount = pageCount.coerceAtLeast(1)
    return ((safeTotalErrors + safePageCount - 1) / safePageCount).coerceAtLeast(1)
}

private fun buildErrorPageText(pageIndex: Int, totalErrors: Int, pageSize: Int): String {
    val safeTotalErrors = totalErrors.coerceAtLeast(0)
    if (safeTotalErrors == 0) return "Showing 0 to 0 of 0 errors"
    val safePageSize = pageSize.coerceAtLeast(1)
    val pageCount = ((safeTotalErrors + safePageSize - 1) / safePageSize).coerceAtLeast(1)
    val safePageIndex = pageIndex.coerceIn(0, pageCount - 1)
    val start = (safePageIndex * safePageSize) + 1
    val end = (start + safePageSize - 1).coerceAtMost(safeTotalErrors)
    return "Showing ${formatImportCount(start)} to ${formatImportCount(end)} of ${formatImportCount(safeTotalErrors)} errors"
}

@Composable
private fun PaginationRow(
    pageIndex: Int,
    pageCount: Int,
    onPageChanged: (Int) -> Unit,
    modifier: Modifier = Modifier
) {
    val safeCount = pageCount.coerceAtLeast(1)
    val safeIndex = pageIndex.coerceIn(0, safeCount - 1)
    val pages = remember(safeIndex, safeCount) {
        when {
            safeCount <= 4 -> (0 until safeCount).toList()
            safeIndex <= 1 -> listOf(0, 1, 2, -1, safeCount - 1)
            safeIndex >= safeCount - 2 -> listOf(0, -1, safeCount - 3, safeCount - 2, safeCount - 1)
            else -> listOf(0, -1, safeIndex - 1, safeIndex, safeIndex + 1, -1, safeCount - 1)
        }.distinct()
    }

    Row(
        modifier = modifier,
        horizontalArrangement = Arrangement.spacedBy(8.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        PagingIconButton(icon = Res.drawable.double_chevron_left, enabled = safeIndex > 0) {
            onPageChanged(0)
        }
        PagingIconButton(icon = Res.drawable.chevron_left, enabled = safeIndex > 0) {
            onPageChanged((safeIndex - 1).coerceAtLeast(0))
        }
        pages.forEach { page ->
            if (page == -1) {
                PagingEllipsis()
            } else {
                PagingNumberButton(
                    number = page + 1,
                    selected = page == safeIndex,
                    onClick = { onPageChanged(page) }
                )
            }
        }
        PagingIconButton(icon = Res.drawable.chevron_right, enabled = safeIndex < safeCount - 1) {
            onPageChanged((safeIndex + 1).coerceAtMost(safeCount - 1))
        }
        PagingIconButton(icon = Res.drawable.double_chevron_right, enabled = safeIndex < safeCount - 1) {
            onPageChanged(safeCount - 1)
        }
    }
}

@Composable
private fun PagingIconButton(
    icon: org.jetbrains.compose.resources.DrawableResource,
    enabled: Boolean,
    onClick: () -> Unit
) {
    Surface(
        modifier = Modifier
            .size(34.dp)
            .clickable(enabled = enabled, onClick = onClick),
        color = ImportsSurface,
        contentColor = if (enabled) ImportsNavy else ImportsMuted,
        shape = RoundedCornerShape(6.dp),
        border = androidx.compose.foundation.BorderStroke(1.dp, ImportsBorder)
    ) {
        Box(contentAlignment = Alignment.Center) {
            Icon(
                painter = painterResource(icon),
                contentDescription = null,
                tint = if (enabled) ImportsNavy else ImportsMuted,
                modifier = Modifier.size(16.dp)
            )
        }
    }
}

@Composable
private fun PagingNumberButton(
    number: Int,
    selected: Boolean,
    onClick: () -> Unit
) {
    Surface(
        modifier = Modifier
            .size(34.dp)
            .clickable(onClick = onClick),
        color = if (selected) ImportsPrimary else ImportsSurface,
        shape = RoundedCornerShape(6.dp),
        border = androidx.compose.foundation.BorderStroke(1.dp, if (selected) ImportsPrimary else ImportsBorder)
    ) {
        Box(contentAlignment = Alignment.Center) {
            Text(
                text = number.toString(),
                color = if (selected) Color.White else ImportsNavy,
                fontFamily = interSemiBold(),
                fontWeight = FontWeight.SemiBold
            )
        }
    }
}

@Composable
private fun PagingEllipsis() {
    Surface(
        modifier = Modifier.size(34.dp),
        color = ImportsSurface,
        shape = RoundedCornerShape(6.dp),
        border = androidx.compose.foundation.BorderStroke(1.dp, ImportsBorder)
    ) {
        Box(contentAlignment = Alignment.Center) {
            Text(
                text = "…",
                color = ImportsMuted,
                fontWeight = FontWeight.Bold
            )
        }
    }
}

@Composable
fun ImportsPageContent(
    state: ImportsUiState,
    onEvent: (ImportsUiEvent) -> Unit,
    contextLine: String? = null,
    headerActions: @Composable RowScope.() -> Unit = {},
    contentHorizontalPadding: Dp = 18.dp,
    contentVerticalPadding: Dp = 12.dp,
    modifier: Modifier = Modifier
) {
    val scrollState = rememberScrollState()
    val pickerScope = rememberCoroutineScope()
    val workbookPickerLauncher = rememberFilePickerLauncher(
        type = PickerType.File(listOf("xlsx")),
        title = "Select School Setup Workbook"
    ) { selectedFile ->
        if (selectedFile == null) {
            onEvent(ImportsUiEvent.WorkbookLoadFailed("No workbook selected"))
            return@rememberFilePickerLauncher
        }
        onEvent(ImportsUiEvent.WorkbookLoadStarted(selectedFile.name))
        pickerScope.launch {
            // Give Compose one frame to render the loading overlay before file I/O begins.
            yield()
            val bytes = runCatching { selectedFile.readBytes() }
                .getOrElse {
                    onEvent(ImportsUiEvent.WorkbookLoadFailed(it.message ?: "Unable to read the selected workbook"))
                    return@launch
                }
            if (bytes.size > MAX_WORKBOOK_BYTES) {
                onEvent(ImportsUiEvent.WorkbookLoadFailed("Workbook is too large. Maximum size is 25 MB."))
                return@launch
            }
            onEvent(ImportsUiEvent.WorkbookPrepared(selectedFile.name, bytes))
            val preview = parseImportsWorkbook(bytes, selectedFile.name)
                .getOrElse {
                    onEvent(ImportsUiEvent.WorkbookLoadFailed(it.message ?: "Unable to parse the workbook"))
                    return@launch
                }
            onEvent(ImportsUiEvent.WorkbookLoaded(preview))
        }
    }
    val filteredErrorRows = remember(state.errorRows, state.selectedSheet) {
        if (state.selectedSheet.equals("All Sheets", ignoreCase = true)) {
            state.errorRows
        } else {
            state.errorRows.filter { it.sheetName.equals(state.selectedSheet, ignoreCase = true) }
        }
    }
    val filteredErrorPageCount = remember(filteredErrorRows.size) {
        if (filteredErrorRows.isEmpty()) 1 else ((filteredErrorRows.size + 9) / 10).coerceAtLeast(1)
    }
    Box(
        modifier = modifier
            .fillMaxSize()
            .background(ImportsBackground)
    ) {
            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(horizontal = contentHorizontalPadding, vertical = contentVerticalPadding)
            ) {
                ImportsPageHeader(
                    title = state.pageTitle,
                    subtitle = state.validationSubtitle,
                    contextLine = contextLine,
                    headerActions = headerActions
                )
                Spacer(modifier = Modifier.height(16.dp))
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .weight(1f)
                    .verticalScroll(scrollState),
                verticalArrangement = Arrangement.spacedBy(14.dp)
            ) {
                ImportsStepper(steps = state.steps)

                if (state.errorMessage.isNotBlank()) {
                    Card(
                        modifier = Modifier.fillMaxWidth(),
                        shape = RoundedCornerShape(8.dp),
                        colors = CardDefaults.cardColors(containerColor = ImportsDangerBg),
                        border = androidx.compose.foundation.BorderStroke(1.dp, ImportsDanger.copy(alpha = 0.22f))
                    ) {
                        Text(
                            text = state.errorMessage,
                            color = ImportsDanger,
                            fontFamily = interSemiBold(),
                            fontWeight = FontWeight.SemiBold,
                            modifier = Modifier.padding(horizontal = 18.dp, vertical = 14.dp)
                        )
                    }
                }

                BoxWithConstraints(modifier = Modifier.fillMaxWidth()) {
                    // The browser shell and navigation rail consume part of the
                    // viewport, so a visually small desktop/tablet content area
                    // can still be wide enough for two readable cards.
                    // Keep the summary cards in a two-column layout for the
                    // compact application shell; the cards remain readable
                    // because their content rows are independently stacked.
                    val veryCompact = false
                    // Three cards fit comfortably once the content area is at
                    // least 1000dp wide. Browser density and the shell's rail
                    // make a physically wide viewport report a smaller Compose
                    // width than its screenshot pixel width.
                    val twoColumn = maxWidth < 1000.dp && !veryCompact
                    if (veryCompact) {
                        Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
                            ExistingDetailsCard(
                                rows = state.existingDetails,
                                onDownloadCurrentData = { onEvent(ImportsUiEvent.DownloadCurrentDataClicked) },
                                onDownloadTemplate = { onEvent(ImportsUiEvent.DownloadTemplateClicked) }
                            )
                            NewImportDetailsCard(
                                rows = state.newImportDetails,
                                onUpload = { workbookPickerLauncher.launch() }
                            )
                            ValidationSummaryCard(
                                rows = state.validationDetails,
                                lastUpdated = state.validationLastUpdated,
                                onValidate = { onEvent(ImportsUiEvent.ValidateFileClicked) }
                            )
                        }
                    } else if (twoColumn) {
                        Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
                            Row(
                                modifier = Modifier.fillMaxWidth(),
                                horizontalArrangement = Arrangement.spacedBy(14.dp)
                            ) {
                                ExistingDetailsCard(
                                    rows = state.existingDetails,
                                    onDownloadCurrentData = { onEvent(ImportsUiEvent.DownloadCurrentDataClicked) },
                                    onDownloadTemplate = { onEvent(ImportsUiEvent.DownloadTemplateClicked) },
                                    modifier = Modifier.weight(1f)
                                )
                                NewImportDetailsCard(
                                    rows = state.newImportDetails,
                                    onUpload = { workbookPickerLauncher.launch() },
                                    modifier = Modifier.weight(1f)
                                )
                            }
                            ValidationSummaryCard(
                                rows = state.validationDetails,
                                lastUpdated = state.validationLastUpdated,
                                onValidate = { onEvent(ImportsUiEvent.ValidateFileClicked) }
                            )
                        }
                    } else {
                        Row(horizontalArrangement = Arrangement.spacedBy(14.dp)) {
                            ExistingDetailsCard(
                                rows = state.existingDetails,
                                onDownloadCurrentData = { onEvent(ImportsUiEvent.DownloadCurrentDataClicked) },
                                onDownloadTemplate = { onEvent(ImportsUiEvent.DownloadTemplateClicked) },
                                modifier = Modifier.weight(1f)
                            )
                            NewImportDetailsCard(
                                rows = state.newImportDetails,
                                onUpload = { workbookPickerLauncher.launch() },
                                modifier = Modifier.weight(1.08f)
                            )
                            ValidationSummaryCard(
                                rows = state.validationDetails,
                                lastUpdated = state.validationLastUpdated,
                                onValidate = { onEvent(ImportsUiEvent.ValidateFileClicked) },
                                modifier = Modifier.weight(1.16f)
                            )
                        }
                    }
                }

                ImportErrorTableCard(
                    totalErrorsLabel = state.totalErrorsLabel,
                    helpText = state.errorHelpText,
                    sheetOptions = state.sheetOptions,
                    selectedSheet = state.selectedSheet,
                    onSheetSelected = { onEvent(ImportsUiEvent.SheetSelected(it)) },
                    onFilterClick = { onEvent(ImportsUiEvent.FilterClicked) },
                    rows = filteredErrorRows,
                    pageText = state.errorPageText,
                    pageIndex = state.pageIndex.coerceIn(0, filteredErrorPageCount - 1),
                    pageCount = filteredErrorPageCount,
                    onPageChanged = { onEvent(ImportsUiEvent.PageChanged(it)) }
                )
                Spacer(modifier = Modifier.height(8.dp))
                FooterActions(
                    onCancel = { onEvent(ImportsUiEvent.CancelClicked) },
                    onContinueReview = { onEvent(ImportsUiEvent.ContinueReviewClicked) },
                    canContinue = state.serverValidationCompleted && !state.isLoading
                )
            }
        }

        ApiLoadingOverlay(
            isVisible = state.isLoading,
            title = "Updating data",
            subtitle = "Please wait while the workbook request finishes."
        )

        if (state.structureValidationErrors.isNotEmpty()) {
            AppConfirmationDialog(
                onDismiss = { onEvent(ImportsUiEvent.DismissStructureErrors) },
                title = "Template structure issue",
                subtitle = "Fix these workbook issues before data validation can begin.",
                confirmLabel = "Got it",
                onConfirm = { onEvent(ImportsUiEvent.DismissStructureErrors) },
                dismissLabel = "Close",
                tone = AppConfirmationDialogTone.Primary,
                bodyText = "Download the School Setup template and fill in its data. Keep the tab names, tab order, and column headers unchanged.",
                content = {
                    Column(
                        modifier = Modifier.fillMaxWidth().heightIn(max = 210.dp).verticalScroll(rememberScrollState()),
                        verticalArrangement = Arrangement.spacedBy(8.dp)
                    ) {
                        state.structureValidationErrors.forEachIndexed { index, issue ->
                            Text(
                                text = "${index + 1}. $issue",
                                color = ImportsDanger,
                                fontSize = 13.sp,
                                lineHeight = 18.sp
                            )
                        }
                    }
                }
            )
        }

        if (state.showReviewWarning) {
            AppConfirmationDialog(
                onDismiss = { onEvent(ImportsUiEvent.DismissReviewWarning) },
                title = "Review with validation issues?",
                subtitle = "There are issues in the Excel file.",
                confirmLabel = "OK",
                onConfirm = { onEvent(ImportsUiEvent.ConfirmContinueReviewClicked) },
                dismissLabel = "Cancel",
                tone = AppConfirmationDialogTone.Primary,
                bodyText = "The workbook still contains validation issues. Do you still want to review the imported records?",
                content = {
                    ImportsOutlineButton(
                        label = "Download Error Details",
                        icon = painterResource(Res.drawable.download),
                        onClick = { onEvent(ImportsUiEvent.DownloadErrorDetailsClicked) },
                        modifier = Modifier.fillMaxWidth(),
                        borderColor = ImportsPrimary,
                        contentColor = ImportsPrimary,
                        height = 44.dp,
                        horizontalPadding = 18.dp
                    )
                }
            )
        }

    }
}

@Composable
private fun ExistingDetailsCard(
    rows: List<ImportSummaryRow>,
    onDownloadCurrentData: () -> Unit,
    onDownloadTemplate: () -> Unit,
    modifier: Modifier = Modifier
) {
    ImportSummaryCard(
        index = 1,
        title = "Workbook Overview",
        subtitle = "Preview of the parsed sheets loaded from the workbook.",
        icon = painterResource(Res.drawable.database_download),
        iconTint = ImportsSuccess,
        iconBackground = ImportsSuccessBg,
        rows = rows,
        modifier = modifier
    ) {
        Column(verticalArrangement = Arrangement.spacedBy(10.dp)) {
            ImportCardActionButton(
                label = "Download Current Data",
                icon = painterResource(Res.drawable.download),
                onClick = onDownloadCurrentData,
                modifier = Modifier.fillMaxWidth(),
                contentColor = ImportsSuccess,
                borderColor = ImportsSuccess
            )
            ImportCardActionButton(
                label = "Download Template",
                icon = painterResource(Res.drawable.document),
                onClick = onDownloadTemplate,
                modifier = Modifier.fillMaxWidth(),
                contentColor = ImportsPrimary,
                borderColor = ImportsPrimary
            )
        }
    }
}

@Composable
private fun NewImportDetailsCard(
    rows: List<ImportSummaryRow>,
    onUpload: () -> Unit,
    modifier: Modifier = Modifier
) {
    val hasSelectedFile = rows.firstOrNull { it.label == "File Name" }
        ?.value
        ?.let { it.isNotBlank() && !it.equals("No file selected", ignoreCase = true) && !it.equals("Not selected", ignoreCase = true) }
        ?: false
    ImportSummaryCard(
        index = 2,
        title = "New Import Details",
        subtitle = "Select a workbook to validate and import.",
        icon = painterResource(Res.drawable.excel_file),
        iconTint = ImportsSuccess,
        iconBackground = ImportsSuccessBg,
        rows = rows,
        modifier = modifier,
    ) {
        Column(verticalArrangement = Arrangement.spacedBy(10.dp)) {
            ImportsOutlineButton(
                label = if (hasSelectedFile) "Change File" else "Select File",
                icon = painterResource(Res.drawable.cloud_upload),
                onClick = onUpload,
                modifier = Modifier.fillMaxWidth(),
                borderColor = ImportsPrimary,
                contentColor = ImportsPrimary,
                height = 48.dp,
                horizontalPadding = 20.dp
            )
            Text(
                text = "Supported format: .xlsx    |    Max file size: 10MB",
                color = ImportsNavy,
                style = MaterialTheme.typography.bodySmall,
                fontWeight = FontWeight.Medium,
                textAlign = TextAlign.Center,
                modifier = Modifier.fillMaxWidth().padding(top = 2.dp)
            )
        }
    }
}

@Composable
private fun ValidationSummaryCard(
    rows: List<ImportSummaryRow>,
    lastUpdated: String,
    onValidate: () -> Unit,
    modifier: Modifier = Modifier
) {
    ImportSummaryCard(
        index = 3,
        title = "Validation Summary",
        subtitle = "Validate the uploaded file to check for errors.",
        icon = painterResource(Res.drawable.clipboard_check),
        iconTint = ImportsPurple,
        iconBackground = ImportsPurpleBg,
        rows = rows,
        modifier = modifier,
    ) {
        Column(verticalArrangement = Arrangement.spacedBy(10.dp)) {
            ImportsOutlineButton(
                label = "Validate File",
                icon = painterResource(Res.drawable.circle_check),
                onClick = onValidate,
                modifier = Modifier.fillMaxWidth(),
                borderColor = ImportsPurple,
                contentColor = ImportsPurple,
                height = 48.dp,
                horizontalPadding = 20.dp
            )
            Text(
                text = lastUpdated,
                color = ImportsNavy,
                style = MaterialTheme.typography.bodySmall,
                fontWeight = FontWeight.Medium,
                textAlign = TextAlign.Center,
                modifier = Modifier.fillMaxWidth().padding(top = 2.dp)
            )
        }
    }
}

@Composable
private fun FooterActions(
    onCancel: () -> Unit,
    onContinueReview: () -> Unit,
    canContinue: Boolean
) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        ImportsOutlineButton(
            label = "Cancel",
            icon = null,
            onClick = onCancel,
            modifier = Modifier.size(width = ImportFooterButtonWidth, height = ImportFooterButtonHeight),
            borderColor = ImportsBorder,
            contentColor = ImportsNavy,
            height = ImportFooterButtonHeight,
            horizontalPadding = 22.dp
        )
        ImportsFilledButton(
            label = "Continue Review",
            icon = painterResource(Res.drawable.arrow_right),
            onClick = onContinueReview,
            modifier = Modifier.size(width = ImportFooterButtonWidth, height = ImportFooterButtonHeight),
            backgroundColor = ImportsPrimary,
            contentColor = Color.White,
            height = ImportFooterButtonHeight,
            horizontalPadding = 22.dp,
            enabled = canContinue
        )
    }
}

@Composable
fun ImportsReviewPageContent(
    state: ImportsUiState,
    onEvent: (ImportsUiEvent) -> Unit,
    onBackToValidationSummary: () -> Unit,
    contextLine: String? = null,
    headerActions: @Composable RowScope.() -> Unit = {},
    contentHorizontalPadding: Dp = 18.dp,
    contentVerticalPadding: Dp = 12.dp,
    modifier: Modifier = Modifier
) {
    Box(
        modifier = modifier
            .fillMaxSize()
            .background(ImportsBackground)
    ) {
        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(horizontal = contentHorizontalPadding, vertical = contentVerticalPadding),
            verticalArrangement = Arrangement.spacedBy(14.dp)
        ) {
            ImportsPageHeader(
                title = state.pageTitle,
                subtitle = state.reviewSubtitle,
                contextLine = contextLine,
                headerActions = headerActions
            )
            Spacer(modifier = Modifier.height(2.dp))
            ImportsStepper(steps = state.steps)

            ImportReviewSummaryStrip(summary = state.reviewSummary)

            val reviewTotalRecords = selectedTabCount(state.reviewTabs, state.selectedTabId)
            val reviewPageIndex = state.reviewPageIndexByTab[state.selectedTabId] ?: state.reviewPageIndex
            val reviewPageCountValue = reviewPageCount(
                rowsPerPage = state.rowsPerPage.coerceAtLeast(1),
                totalRecords = reviewTotalRecords
            )
            val safeReviewPageIndex = reviewPageIndex.coerceIn(0, reviewPageCountValue - 1)

            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .weight(1f)
            ) {
                ImportReviewRecordsCard(
                    tabs = state.reviewTabs,
                    selectedTabId = state.selectedTabId,
                    onTabSelected = { onEvent(ImportsUiEvent.TabSelected(it)) },
                    rowsPerPage = state.rowsPerPage,
                    onRowsPerPageChanged = { onEvent(ImportsUiEvent.RowsPerPageChanged(it)) },
                    pageIndex = safeReviewPageIndex,
                    pageCount = reviewPageCountValue,
                    pageText = buildReviewPageText(
                        rowsPerPage = state.rowsPerPage.coerceAtLeast(1),
                        pageIndex = safeReviewPageIndex,
                        totalRecords = reviewTotalRecords
                    ),
                    staffRows = state.staffRecords,
                    subjectRows = state.subjectRecords,
                    classRows = state.classRecords,
                    assignmentRows = state.assignmentRecords,
                    onPageChanged = { onEvent(ImportsUiEvent.PageChanged(it)) },
                    modifier = Modifier.fillMaxSize()
                )
            }

            Spacer(modifier = Modifier.height(12.dp))

            ReviewBottomActions(
                onBackToValidationSummary = onBackToValidationSummary,
                onCancel = { onEvent(ImportsUiEvent.CancelClicked) },
                onSaveRecords = { onEvent(ImportsUiEvent.SaveRecordsClicked) },
                saveCount = state.reviewSummary.readyToSaveRows,
                isSaving = state.isLoading,
                canSave = state.serverValidationCompleted && !state.isLoading
            )
        }

        if (state.showSaveWarning) {
            AppConfirmationDialog(
                onDismiss = { onEvent(ImportsUiEvent.DismissSaveWarning) },
                title = "Save with validation issues?",
                subtitle = "There are issues in the Excel file.",
                confirmLabel = "Save Records",
                onConfirm = { onEvent(ImportsUiEvent.ConfirmSaveRecordsClicked) },
                dismissLabel = "Cancel",
                tone = AppConfirmationDialogTone.Primary,
                bodyText = "The workbook still contains validation issues. Do you still want to save the records?",
                content = {
                    ImportsOutlineButton(
                        label = "Download Error Details",
                        icon = painterResource(Res.drawable.download),
                        onClick = { onEvent(ImportsUiEvent.DownloadErrorDetailsClicked) },
                        modifier = Modifier.fillMaxWidth(),
                        borderColor = ImportsPrimary,
                        contentColor = ImportsPrimary,
                        height = 44.dp,
                        horizontalPadding = 18.dp
                    )
                }
            )
        }
    }

}

@Composable
fun ImportReviewSummaryStrip(
    summary: ImportReviewSummary,
    modifier: Modifier = Modifier
) {
    Card(
        modifier = modifier.fillMaxWidth(),
        shape = RoundedCornerShape(8.dp),
        colors = CardDefaults.cardColors(containerColor = ImportsSoftSurface),
        border = androidx.compose.foundation.BorderStroke(1.dp, ImportsBorder)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 22.dp, vertical = 20.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            ReviewMetaItem(
                icon = painterResource(Res.drawable.file_xlsx),
                label = "File:",
                value = summary.fileName,
                valueColor = ImportsNavy,
                itemWidth = 1.15f,
                modifier = Modifier.weight(1f)
            )
            ReviewMetaDivider()
            ReviewMetaItem(
                icon = painterResource(Res.drawable.calendar),
                label = "Selected On:",
                value = summary.uploadedOn,
                valueColor = ImportsNavy,
                itemWidth = 1.25f,
                modifier = Modifier.weight(1f)
            )
            ReviewMetaDivider()
            ReviewMetaItem(
                icon = painterResource(Res.drawable.records_list),
                label = "Ready to Save:",
                value = formatImportCount(summary.readyToSaveRows),
                suffix = "rows",
                valueColor = ImportsNavy,
                itemWidth = 1.1f,
                modifier = Modifier.weight(1f)
            )
            ReviewMetaDivider()
            ReviewMetaItem(
                icon = painterResource(Res.drawable.check_circle_filled),
                label = "Status:",
                value = summary.status,
                valueColor = ImportsSuccess,
                tint = Color.Unspecified,
                itemWidth = 0.95f,
                modifier = Modifier.weight(1f)
            )
        }
    }
}

private fun formatImportCount(value: Int): String {
    return value.toString().reversed().chunked(3).joinToString(",").reversed()
}

private fun selectedTabCount(tabs: List<ImportTabUiModel>, selectedTabId: String): Int {
    return tabs.firstOrNull { it.id.equals(selectedTabId, ignoreCase = true) }?.count ?: 0
}

private fun buildReviewPageText(rowsPerPage: Int, pageIndex: Int, totalRecords: Int): String {
    val safeRowsPerPage = rowsPerPage.coerceAtLeast(1)
    val safeTotalRecords = totalRecords.coerceAtLeast(0)
    if (safeTotalRecords == 0) {
        return "Showing 0 to 0 of 0 records"
    }
    val safePageCount = reviewPageCount(safeRowsPerPage, safeTotalRecords)
    val safePageIndex = pageIndex.coerceIn(0, safePageCount - 1)
    val start = (safePageIndex * safeRowsPerPage) + 1
    val end = (start + safeRowsPerPage - 1).coerceAtMost(safeTotalRecords)
    return "Showing ${formatImportCount(start)} to ${formatImportCount(end)} of ${formatImportCount(totalRecords)} records"
}

private fun reviewPageCount(rowsPerPage: Int, totalRecords: Int): Int {
    val safeRowsPerPage = rowsPerPage.coerceAtLeast(1)
    val safeTotalRecords = totalRecords.coerceAtLeast(1)
    return ((safeTotalRecords + safeRowsPerPage - 1) / safeRowsPerPage).coerceAtLeast(1)
}

@Composable
private fun ReviewMetaItem(
    icon: Painter,
    label: String,
    value: String,
    valueColor: Color,
    tint: Color = ImportsPrimary,
    itemWidth: Float = 1f,
    modifier: Modifier = Modifier,
    suffix: String? = null
) {
    Row(
        modifier = modifier,
        horizontalArrangement = Arrangement.spacedBy(10.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Icon(
            painter = icon,
            contentDescription = null,
            tint = tint,
            modifier = Modifier.size(24.dp)
        )
        Row(
            modifier = Modifier.weight(itemWidth),
            horizontalArrangement = Arrangement.spacedBy(4.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(
                text = label,
                color = ImportsNavy,
                fontFamily = interSemiBold(),
                fontWeight = FontWeight.SemiBold,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
            Text(
                text = value,
                color = valueColor,
                fontFamily = interSemiBold(),
                fontWeight = FontWeight.SemiBold,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
            if (suffix != null) {
                Text(
                    text = suffix,
                    color = ImportsNavy,
                    fontFamily = interSemiBold(),
                    fontWeight = FontWeight.SemiBold,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
            }
        }
    }
}

@Composable
private fun ReviewMetaDivider() {
    Box(
        modifier = Modifier
            .padding(horizontal = 18.dp)
            .size(width = 1.dp, height = 30.dp)
            .background(ImportsBorder)
    )
}

@Composable
private fun ImportReviewRecordsCard(
    tabs: List<ImportTabUiModel>,
    selectedTabId: String,
    onTabSelected: (String) -> Unit,
    rowsPerPage: Int,
    onRowsPerPageChanged: (Int) -> Unit,
    pageText: String,
    pageIndex: Int,
    pageCount: Int,
    staffRows: List<StaffRecordUiModel>,
    subjectRows: List<SubjectRecordUiModel>,
    classRows: List<ClassRecordUiModel>,
    assignmentRows: List<TeachingAssignmentRecordUiModel>,
    onPageChanged: (Int) -> Unit,
    modifier: Modifier = Modifier
) {
    val safeRowsPerPage = rowsPerPage.coerceAtLeast(1)
    var rowsPerPageExpanded by remember { mutableStateOf(false) }

    Card(
        modifier = modifier.fillMaxWidth(),
        shape = RoundedCornerShape(8.dp),
        colors = CardDefaults.cardColors(containerColor = ImportsSurface),
        border = androidx.compose.foundation.BorderStroke(1.dp, ImportsBorder)
    ) {
        Column(modifier = Modifier.fillMaxSize()) {
            Box(
                modifier = Modifier
                    .padding(horizontal = 22.dp, vertical = 10.dp)
                    .fillMaxWidth()
                    .horizontalScroll(rememberScrollState())
            ) {
                ImportReviewTabs(
                    tabs = tabs,
                    selectedTabId = selectedTabId,
                    onTabSelected = onTabSelected
                )
            }
            HorizontalDivider(color = ImportsBorder)

            ImportReviewTable(
                selectedTabId = selectedTabId,
                staffRows = staffRows,
                subjectRows = subjectRows,
                classRows = classRows,
                assignmentRows = assignmentRows,
                rowsPerPage = safeRowsPerPage,
                rowsPerPageExpanded = rowsPerPageExpanded,
                onRowsPerPageExpandedChange = { rowsPerPageExpanded = it },
                onRowsPerPageChanged = onRowsPerPageChanged,
                pageIndex = pageIndex,
                modifier = Modifier.weight(1f)
            )

            HorizontalDivider(color = ImportsBorder)

            ReviewPaginationBar(
                pageText = pageText,
                pageIndex = pageIndex,
                pageCount = pageCount,
                onPageChanged = onPageChanged,
                rowsPerPage = rowsPerPage,
                rowsPerPageExpanded = rowsPerPageExpanded,
                onRowsPerPageExpandedChange = { rowsPerPageExpanded = it },
                onRowsPerPageChanged = onRowsPerPageChanged
            )
        }
    }
}

@Composable
fun ImportReviewTabs(
    tabs: List<ImportTabUiModel>,
    selectedTabId: String,
    onTabSelected: (String) -> Unit,
    modifier: Modifier = Modifier
) {
    Row(
        modifier = modifier,
        horizontalArrangement = Arrangement.spacedBy(36.dp),
        verticalAlignment = Alignment.Bottom
    ) {
        tabs.forEach { tab ->
            val selected = tab.id.equals(selectedTabId, ignoreCase = true)
            Column(
                modifier = Modifier
                    .clickable { onTabSelected(tab.id) }
                    .padding(bottom = 2.dp),
                verticalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                Text(
                    text = "${tab.title} (${formatImportCount(tab.count)})",
                    color = if (selected) ImportsPrimary else ImportsNavy,
                    fontFamily = interSemiBold(),
                    fontWeight = FontWeight.SemiBold,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                Box(
                    modifier = Modifier
                        .height(2.dp)
                        .width(if (selected) 126.dp else 0.dp)
                        .background(if (selected) ImportsPrimary else Color.Transparent)
                )
            }
        }
    }
}

@Composable
private fun ImportReviewScrollableSurface(
    minContentWidth: Dp,
    modifier: Modifier = Modifier,
    gridWeights: List<Float>? = null,
    horizontalPadding: Dp = 18.dp,
    dividerWidth: Dp = 1.5.dp,
    dividerColor: Color = ImportsBorder,
    content: @Composable ColumnScope.() -> Unit
) {
    BoxWithConstraints(modifier = modifier.fillMaxWidth()) {
        val contentWidth = maxOf(maxWidth, minContentWidth)
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .horizontalScroll(rememberScrollState())
        ) {
            Box(modifier = Modifier.width(contentWidth)) {
                Column(modifier = Modifier.fillMaxWidth()) {
                    content()
                }
                if (gridWeights != null) {
                    AdminListSpreadsheetGridOverlay(
                        weights = gridWeights,
                        modifier = Modifier.fillMaxSize(),
                        horizontalPadding = horizontalPadding,
                        dividerWidth = dividerWidth,
                        dividerColor = dividerColor
                    )
                }
            }
        }
    }
}

@Composable
private fun ImportReviewTable(
    selectedTabId: String,
    staffRows: List<StaffRecordUiModel>,
    subjectRows: List<SubjectRecordUiModel>,
    classRows: List<ClassRecordUiModel>,
    assignmentRows: List<TeachingAssignmentRecordUiModel>,
    rowsPerPage: Int,
    rowsPerPageExpanded: Boolean,
    onRowsPerPageExpandedChange: (Boolean) -> Unit,
    onRowsPerPageChanged: (Int) -> Unit,
    pageIndex: Int,
    modifier: Modifier = Modifier
) {
    Column(modifier = modifier.fillMaxWidth()) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 18.dp, vertical = 14.dp),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(
                text = when (selectedTabId) {
                    "subjects" -> "Subject Records"
                    "classes" -> "Class Records"
                    "teaching-assignments" -> "Teaching Assignment Records"
                    else -> "Staff Records"
                },
                color = ImportsNavy,
                style = MaterialTheme.typography.titleMedium,
                fontFamily = interBold(),
                fontWeight = FontWeight.Bold
            )
        }

        HorizontalDivider(color = ImportsBorder)

        BoxWithConstraints(modifier = Modifier.weight(1f).fillMaxWidth()) {
            when (selectedTabId) {
                "subjects" -> SubjectTable(
                    subjectRows = subjectRows,
                    rowsPerPage = rowsPerPage,
                    pageIndex = pageIndex
                )
                "classes" -> ClassTable(
                    classRows = classRows,
                    rowsPerPage = rowsPerPage,
                    pageIndex = pageIndex
                )
                "teaching-assignments" -> TeachingAssignmentTable(
                    assignmentRows = assignmentRows,
                    rowsPerPage = rowsPerPage,
                    pageIndex = pageIndex
                )
                else -> StaffTable(
                    staffRows = staffRows,
                    rowsPerPage = rowsPerPage,
                    pageIndex = pageIndex
                )
            }
        }
    }
}

@Composable
private fun StaffTable(staffRows: List<StaffRecordUiModel>, rowsPerPage: Int, pageIndex: Int) {
    val visibleRows = rememberPageRows(staffRows, rowsPerPage, pageIndex)
    ImportReviewScrollableSurface(
        minContentWidth = ImportStaffTableMinWidth,
        gridWeights = listOf(0.07f, 0.09f, 0.16f, 0.10f, 0.18f, 0.14f, 0.13f, 0.13f)
    ) {
        AdminListSpreadsheetHeaderRow(
            columns = listOf(
                AdminListHeaderColumn("Row No.", 0.07f),
                AdminListHeaderColumn("Staff ID", 0.09f),
                AdminListHeaderColumn("Staff Name", 0.16f),
                AdminListHeaderColumn("Gender", 0.10f),
                AdminListHeaderColumn("Staff Role", 0.18f),
                AdminListHeaderColumn("Auth Role", 0.14f),
                AdminListHeaderColumn("Mobile Number", 0.13f),
                AdminListHeaderColumn("Email Address", 0.13f)
            ),
            height = 42.dp,
            horizontalPadding = 18.dp,
            showVerticalDividers = false,
            labelColor = ImportsNavy
        )
        HorizontalDivider(color = ImportsBorder)
        LazyColumn(modifier = Modifier.fillMaxWidth()) {
            items(visibleRows) { row ->
                StaffRecordRow(row = row)
                HorizontalDivider(color = ImportsBorder)
            }
        }
    }
}

@Composable
private fun SubjectTable(subjectRows: List<SubjectRecordUiModel>, rowsPerPage: Int, pageIndex: Int) {
    val visibleRows = rememberPageRows(subjectRows, rowsPerPage, pageIndex)
    ImportReviewScrollableSurface(
        minContentWidth = ImportSubjectTableMinWidth,
        gridWeights = listOf(0.12f, 0.16f, 0.36f, 0.36f)
    ) {
        AdminListSpreadsheetHeaderRow(
            columns = listOf(
                AdminListHeaderColumn("Row No.", 0.12f),
                AdminListHeaderColumn("Subject Code", 0.16f),
                AdminListHeaderColumn("Subject Name", 0.36f),
                AdminListHeaderColumn("Category", 0.36f)
            ),
            height = 42.dp,
            horizontalPadding = 18.dp,
            showVerticalDividers = false,
            labelColor = ImportsNavy
        )
        HorizontalDivider(color = ImportsBorder)
        LazyColumn(modifier = Modifier.fillMaxWidth()) {
            items(visibleRows) { row ->
                AdminListSpreadsheetRow(
                    cells = listOf(
                        AdminListSpreadsheetCell(0.12f) { ImportSpreadsheetText(row.rowNo.toString()) },
                        AdminListSpreadsheetCell(0.16f) { ImportSpreadsheetText(row.subjectCode) },
                        AdminListSpreadsheetCell(0.36f) { ImportSpreadsheetText(row.subjectName) },
                        AdminListSpreadsheetCell(0.36f) { ImportSpreadsheetText(row.category) }
                    ),
                    height = ImportReviewRowHeight,
                    horizontalPadding = 18.dp,
                    showVerticalDividers = false,
                    backgroundColor = ImportsSurface,
                    dividerColor = ImportsBorder
                )
                HorizontalDivider(color = ImportsBorder)
            }
        }
    }
}

@Composable
private fun ClassTable(classRows: List<ClassRecordUiModel>, rowsPerPage: Int, pageIndex: Int) {
    val visibleRows = rememberPageRows(classRows, rowsPerPage, pageIndex)
    ImportReviewScrollableSurface(
        minContentWidth = ImportClassTableMinWidth,
        gridWeights = listOf(0.12f, 0.22f, 0.12f, 0.54f)
    ) {
        AdminListSpreadsheetHeaderRow(
            columns = listOf(
                AdminListHeaderColumn("Row No.", 0.12f),
                AdminListHeaderColumn("Class", 0.22f),
                AdminListHeaderColumn("Section", 0.12f),
                AdminListHeaderColumn("Subject Codes", 0.54f)
            ),
            height = 42.dp,
            horizontalPadding = 18.dp,
            showVerticalDividers = false,
            labelColor = ImportsNavy
        )
        HorizontalDivider(color = ImportsBorder)
        LazyColumn(modifier = Modifier.fillMaxWidth()) {
            items(visibleRows) { row ->
                AdminListSpreadsheetRow(
                    cells = listOf(
                        AdminListSpreadsheetCell(0.12f) { ImportSpreadsheetText(row.rowNo.toString()) },
                        AdminListSpreadsheetCell(0.22f) { ImportSpreadsheetText(row.className) },
                        AdminListSpreadsheetCell(0.12f) { ImportSpreadsheetText(row.section) },
                        AdminListSpreadsheetCell(0.54f) { ImportSpreadsheetText(row.subjectCodes) }
                    ),
                    height = ImportReviewRowHeight,
                    horizontalPadding = 18.dp,
                    showVerticalDividers = false,
                    backgroundColor = ImportsSurface,
                    dividerColor = ImportsBorder
                )
                HorizontalDivider(color = ImportsBorder)
            }
        }
    }
}

@Composable
private fun TeachingAssignmentTable(assignmentRows: List<TeachingAssignmentRecordUiModel>, rowsPerPage: Int, pageIndex: Int) {
    val visibleRows = rememberPageRows(assignmentRows, rowsPerPage, pageIndex)
    ImportReviewScrollableSurface(
        minContentWidth = ImportAssignmentTableMinWidth,
        gridWeights = listOf(0.08f, 0.12f, 0.22f, 0.16f, 0.42f)
    ) {
        AdminListSpreadsheetHeaderRow(
            columns = listOf(
                AdminListHeaderColumn("Row No.", 0.08f),
                AdminListHeaderColumn("Staff ID", 0.12f),
                AdminListHeaderColumn("Staff Name", 0.22f),
                AdminListHeaderColumn("Class Teacher For", 0.16f),
                AdminListHeaderColumn("Assigned Allocations (Class : Subject)", 0.42f)
            ),
            height = 42.dp,
            horizontalPadding = 18.dp,
            dividerWidth = 1.5.dp,
            showVerticalDividers = false,
            labelColor = ImportsNavy
        )
        HorizontalDivider(color = ImportsBorder)
        LazyColumn(modifier = Modifier.fillMaxWidth()) {
            items(visibleRows) { row ->
                AdminListSpreadsheetRow(
                    cells = listOf(
                        AdminListSpreadsheetCell(0.08f) { ImportSpreadsheetText(row.rowNo.toString()) },
                        AdminListSpreadsheetCell(0.12f) { ImportSpreadsheetText(row.staffId) },
                        AdminListSpreadsheetCell(0.22f) { ImportSpreadsheetText(row.staffName) },
                        AdminListSpreadsheetCell(0.16f) {
                            ImportSpreadsheetText(
                                text = row.classTeacherFor,
                                color = if (row.classTeacherFor == "-") ImportsNavy else ImportsSuccess
                            )
                        },
                        AdminListSpreadsheetCell(0.42f) {
                            FlowAllocationPills(
                                allocations = row.allocations,
                                modifier = Modifier.fillMaxWidth()
                            )
                        }
                    ),
                    height = null,
                    minHeight = ImportReviewAssignmentRowMinHeight,
                    horizontalPadding = 18.dp,
                    dividerWidth = 1.5.dp,
                    showVerticalDividers = false,
                    backgroundColor = ImportsSurface,
                    dividerColor = ImportsBorder
                )
                HorizontalDivider(color = ImportsBorder)
            }
        }
    }
}

@Composable
private fun <T> rememberPageRows(rows: List<T>, rowsPerPage: Int, pageIndex: Int): List<T> {
    val safeRowsPerPage = rowsPerPage.coerceAtLeast(1)
    val safePageIndex = pageIndex.coerceAtLeast(0)
    return remember(rows, safeRowsPerPage, safePageIndex) {
        val fromIndex = safePageIndex * safeRowsPerPage
        if (fromIndex >= rows.size) {
            emptyList()
        } else {
            rows.drop(fromIndex).take(safeRowsPerPage)
        }
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun FlowAllocationPills(
    allocations: List<AssignmentChipUiModel>,
    modifier: Modifier = Modifier
) {
    FlowRow(
        modifier = modifier,
        horizontalArrangement = Arrangement.spacedBy(10.dp),
        verticalArrangement = Arrangement.spacedBy(8.dp)
    ) {
        allocations.forEach { chip ->
            Surface(
                color = chip.background,
                shape = RoundedCornerShape(4.dp)
            ) {
                Text(
                    text = chip.label,
                    color = chip.contentColor,
                    fontFamily = interSemiBold(),
                    fontWeight = FontWeight.SemiBold,
                    modifier = Modifier.padding(horizontal = 12.dp, vertical = ImportReviewChipPaddingY)
                )
            }
        }
    }
}

@Composable
private fun ImportSpreadsheetText(
    text: String,
    color: Color = ImportsNavy
) {
    Text(
        text = text,
        color = color,
        fontFamily = interMedium(),
        fontWeight = FontWeight.Medium,
        maxLines = 1,
        overflow = TextOverflow.Ellipsis
    )
}

@Composable
private fun ImportSpreadsheetMultilineText(
    text: String,
    color: Color = ImportsNavy
) {
    Text(
        text = text,
        color = color,
        fontFamily = interMedium(),
        fontWeight = FontWeight.Medium,
        softWrap = true
    )
}

@Composable
private fun CompactImportTableRow(
    modifier: Modifier = Modifier,
    height: Dp? = null,
    verticalAlignment: Alignment.Vertical = Alignment.CenterVertically,
    content: @Composable RowScope.() -> Unit
) {
    Row(
        modifier = modifier
            .fillMaxWidth()
            .then(if (height != null) Modifier.height(height) else Modifier)
            .border(0.5.dp, ImportsBorder.copy(alpha = 0.9f))
            .padding(horizontal = 18.dp, vertical = ImportReviewRowPadding),
        verticalAlignment = verticalAlignment,
        content = content
    )
}

@Composable
private fun RowScope.ImportTableCell(
    text: String,
    weight: Float,
    color: Color = ImportsNavy
) {
    Text(
        text = text,
        color = color,
        fontFamily = interMedium(),
        fontWeight = FontWeight.Medium,
        maxLines = 1,
        overflow = TextOverflow.Ellipsis,
        modifier = Modifier.weight(weight)
    )
}

@Composable
private fun StaffRecordRow(
    row: StaffRecordUiModel,
    modifier: Modifier = Modifier
) {
    AdminListSpreadsheetRow(
        modifier = modifier,
        cells = listOf(
            AdminListSpreadsheetCell(0.07f) { ImportSpreadsheetText(row.rowNo.toString()) },
            AdminListSpreadsheetCell(0.09f) { ImportSpreadsheetText(row.staffId) },
            AdminListSpreadsheetCell(0.16f) { ImportSpreadsheetText(row.staffName) },
            AdminListSpreadsheetCell(0.10f) { GenderPill(gender = row.gender) },
            AdminListSpreadsheetCell(0.18f) { ImportSpreadsheetText(row.staffRole) },
            AdminListSpreadsheetCell(0.14f) { ImportSpreadsheetText(row.authRole) },
            AdminListSpreadsheetCell(0.13f) { ImportSpreadsheetText(row.mobileNumber) },
            AdminListSpreadsheetCell(0.13f) { ImportSpreadsheetText(row.emailAddress) }
        ),
        height = 52.dp,
        horizontalPadding = 18.dp,
        showVerticalDividers = false,
        backgroundColor = ImportsSurface,
        dividerColor = ImportsBorder
    )
}

@Composable
private fun RowScope.StaffCell(
    text: String,
    weight: Float,
    modifier: Modifier = Modifier
) {
    Text(
        text = text,
        color = ImportsNavy,
        fontFamily = interMedium(),
        fontWeight = FontWeight.Medium,
        maxLines = 1,
        overflow = TextOverflow.Ellipsis,
        modifier = modifier.weight(weight)
    )
}

@Composable
private fun GenderPill(
    gender: String,
    modifier: Modifier = Modifier
) {
    val background = when (gender.trim().lowercase()) {
        "male" -> ImportsMaleBg
        "female" -> ImportsFemaleBg
        else -> ImportsSurface
    }
    val contentColor = when (gender.trim().lowercase()) {
        "male" -> ImportsMaleText
        "female" -> ImportsFemaleText
        else -> ImportsMuted
    }
    Surface(
        modifier = modifier,
        color = background,
        shape = RoundedCornerShape(6.dp)
    ) {
        Text(
            text = gender.ifBlank { "—" },
            color = contentColor,
            fontFamily = interSemiBold(),
            fontWeight = FontWeight.SemiBold,
            modifier = Modifier.padding(horizontal = 14.dp, vertical = 6.dp)
        )
    }
}

@Composable
private fun ReviewPaginationBar(
    pageText: String,
    pageIndex: Int,
    pageCount: Int,
    onPageChanged: (Int) -> Unit,
    rowsPerPage: Int,
    rowsPerPageExpanded: Boolean,
    onRowsPerPageExpandedChange: (Boolean) -> Unit,
    onRowsPerPageChanged: (Int) -> Unit,
    modifier: Modifier = Modifier
) {
    Box(
        modifier = modifier
            .fillMaxWidth()
            .padding(horizontal = 18.dp, vertical = 12.dp)
    ) {
        Text(
            text = pageText,
            color = ImportsNavy,
            fontFamily = interSemiBold(),
            fontWeight = FontWeight.SemiBold,
            modifier = Modifier.align(Alignment.Center)
        )
        Row(
            modifier = Modifier.align(Alignment.CenterEnd),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(12.dp)
        ) {
            AdminListPagination(
                pageIndex = pageIndex,
                pageCount = pageCount,
                onPageChanged = onPageChanged,
                borderColor = ImportsBorder,
                surfaceColor = ImportsSurface,
                primaryColor = ImportsPrimary,
                navyColor = ImportsNavy,
                mutedColor = ImportsMuted
            )
            Box {
                AdminListRowsPerPageButton(
                    pageSize = rowsPerPage,
                    expanded = rowsPerPageExpanded,
                    onClick = { onRowsPerPageExpandedChange(!rowsPerPageExpanded) },
                    width = 82.dp,
                    height = 42.dp,
                    borderColor = ImportsBorder,
                    surfaceColor = ImportsSurface,
                    contentColor = ImportsNavy,
                    iconTint = ImportsMuted
                )
                AppDropdownMenu(
                    expanded = rowsPerPageExpanded,
                    onDismissRequest = { onRowsPerPageExpandedChange(false) }
                ) {
                    com.schoolconnect.app.feature.common.PaginationPolicy.PAGE_SIZE_OPTIONS.forEach { option ->
                        DropdownMenuItem(
                            text = { Text(option.toString()) },
                            onClick = {
                                onRowsPerPageExpandedChange(false)
                                onRowsPerPageChanged(option)
                            }
                        )
                    }
                }
            }
        }
    }
}

@Composable
private fun ReviewBottomActions(
    onBackToValidationSummary: () -> Unit,
    onCancel: () -> Unit,
    onSaveRecords: () -> Unit,
    saveCount: Int,
    isSaving: Boolean,
    canSave: Boolean,
    modifier: Modifier = Modifier
) {
    Row(
        modifier = modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        BackToBulkImportButton(
            label = "Back to Validation Summary",
            onClick = onBackToValidationSummary,
            modifier = Modifier.size(width = ImportFooterButtonWidth, height = ImportFooterButtonHeight)
        )
        Row(horizontalArrangement = Arrangement.spacedBy(12.dp), verticalAlignment = Alignment.CenterVertically) {
            ImportsOutlineButton(
                label = "Cancel",
                icon = null,
                onClick = onCancel,
                modifier = Modifier.size(width = ImportFooterButtonWidth, height = ImportFooterButtonHeight),
                borderColor = ImportsBorder,
                contentColor = ImportsNavy,
                height = ImportFooterButtonHeight,
                horizontalPadding = 22.dp
            )
            ImportsFilledButton(
                label = if (isSaving) "Saving Records..." else "Save Records (${formatImportCount(saveCount)})",
                icon = painterResource(Res.drawable.arrow_right),
                onClick = onSaveRecords,
                modifier = Modifier.size(width = ImportFooterButtonWidth, height = ImportFooterButtonHeight),
                backgroundColor = ImportsPrimary,
                contentColor = Color.White,
                height = ImportFooterButtonHeight,
                horizontalPadding = 22.dp,
                enabled = !isSaving && canSave
            )
        }
    }
}
